export const DEFAULT_SEGMENT_TITLE_PREFIX = 'Segment';
export const DEFAULT_SEGMENT_TITLE_PATTERN = new RegExp(`^${DEFAULT_SEGMENT_TITLE_PREFIX} (\\d+)$`);
export function parseSegmentNumber(title) {
    const match = DEFAULT_SEGMENT_TITLE_PATTERN.exec(title.trim());
    return match ? Number(match[1]) : null;
}
export function suggestDefaultSegmentTitle(segments) {
    let max = 0;
    for (const segment of segments) {
        const number = parseSegmentNumber(segment.title);
        if (number !== null) {
            max = Math.max(max, number);
        }
    }
    return `${DEFAULT_SEGMENT_TITLE_PREFIX} ${max + 1}`;
}
